export default __webpack_public_path__ + "static/07_V1@2x-a620ca9f2d3501b392fc7da3cd0aed56.png";